import * as angular from 'angular';

"use strict";
angular.module('UserCtrl', ['UserService']);

export default 'UserCtrl'
